export enum SquareInputEventType {
  FOCUS_CLASS_ADDED = 'focusClassAdded',
  FOCUS_CLASS_REMOVED = 'focusClassRemoved',
  ERROR_CLASS_ADDED = 'errorClassAdded',
  ERROR_CLASS_REMOVED = 'errorClassRemoved',
  CARD_BRAND_CHANGED = 'cardBrandChanged',
  POSTAL_CODE_CHANGED = 'postalCodeChanged',
}
